/**
 * New User Permissions which currently only consist READ, CREATE & some EXECUTE permissions
 * In addition has IsSecurity & isDefaultAdmin flags/permissions
 */
export class UserPermissionKeys {
  // Flags
  public static readonly isSecurity = 'isSecurity';
  public static readonly isDefaultAdmin = 'isDefaultAdmin';
  // Admin
  public readonly adminEventTemplateCreate = 'admin/event-template/create';
  public readonly adminEventTemplateRead = 'admin/event-template/read';
  public readonly adminEventTemplateUpdate = 'admin/event-template/update';
  public readonly adminEventTemplateDelete = 'admin/event-template/delete';
  public readonly adminHierarchyTemplateCreate = 'admin/hierarchy-template/create';
  public readonly adminHierarchyTemplateRead = 'admin/hierarchy-template/read';
  public readonly adminHierarchyTemplateUpdate = 'admin/hierarchy-template/update';
  public readonly adminHierarchyTemplateDelete = 'admin/hierarchy-template/delete';
  public readonly adminInspectionTemplateCreate = 'admin/inspection-template/create';
  public readonly adminInspectionTemplateRead = 'admin/inspection-template/read';
  public readonly adminInspectionTemplateUpdate = 'admin/inspection-template/update';
  public readonly adminInspectionTemplateDelete = 'admin/inspection-template/delete';
  public readonly adminLookupCreate = 'admin/lookup/create';
  public readonly adminLookupRead = 'admin/lookup/read';
  public readonly adminLookupEdit = 'admin/lookup/update';
  public readonly adminLookupDelete = 'admin/lookup/delete';
  public readonly adminLookupDownload = 'admin/lookup/execute';
  public readonly adminMaintenanceMaintenanceStrategyCreate = 'admin/maintenance/maintenance-strategy/create';
  public readonly adminMaintenanceMaintenanceStrategyUpdate = 'admin/maintenance/maintenance-strategy/update';
  public readonly adminMaintenanceMaintenanceStrategyRead = 'admin/maintenance/maintenance-strategy/read';
  public readonly adminMaintenancePerformanceStandardRead = 'admin/maintenance/performance-standard/read';
  public readonly adminMaintenancePerformanceStandardCreate = 'admin/maintenance/performance-standard/create';
  public readonly adminMaintenancePerformanceStandardUpdate = 'admin/maintenance/performance-standard/update';
  public readonly adminMaintenancePlannedMaintenanceRead = 'admin/maintenance/planned-maintenance/read';
  public readonly adminMaintenancePlannedMaintenanceUpdate = 'admin/maintenance/planned-maintenance/update';
  public readonly adminMaintenancePlannedMaintenanceCreate = 'admin/maintenance/planned-maintenance/create';
  public readonly adminMasterAttributeCreate = 'admin/master-attribute/create';
  public readonly adminMasterAttributeUpdate = 'admin/master-attribute/update';
  public readonly adminMasterAttributeRead = 'admin/master-attribute/read';
  public readonly adminMasterInspectionMethodCreate = 'admin/master-inspection-method/create';
  public readonly adminMasterInspectionMethodUpdate = 'admin/master-inspection-method/update';
  public readonly adminMasterInspectionMethodDelete = 'admin/master-inspection-method/delete';
  public readonly adminMasterInspectionMethodRead = 'admin/master-inspection-method/read';
  public readonly adminModelCreate = 'admin/model/create';
  public readonly adminModelRead = 'admin/model/read';
  public readonly adminModelMitigationsCreate = 'admin/model/mitigations/create';
  public readonly adminModelMitigationsRead = 'admin/model/mitigations/read';
  public readonly adminOrganisationCreate = 'admin/organisation/create';
  public readonly adminOrganisationRead = 'admin/organisation/read';
  public readonly adminOrganisationEdit = 'admin/organisation/update';
  public readonly adminRiskMatrixCreate = 'admin/risk-matrix/create';
  public readonly adminRiskMatrixRead = 'admin/risk-matrix/read';
  public readonly adminRiskMatrixUpdate = 'admin/risk-matrix/update';
  public readonly adminSiteCreate = 'admin/site/create';
  public readonly adminSiteRead = 'admin/site/read';
  public readonly adminUomCreate = 'admin/uom/create';
  public readonly adminUomRead = 'admin/uom/read';
  public readonly adminUomUpdate = 'admin/uom/update';
  public readonly adminDataUploadExecute = 'admin/data-upload/execute';
  public readonly adminUpdateOperationsRead = 'admin/update-operations/read';
  public readonly adminUpdateOperationsUpdate = 'admin/update-operations/update';

  // Model Manager
  public readonly adminModelManagerView = 'admin/model-manager/read';
  public readonly adminModelManagerEdit = 'admin/model-manager/update';
  public readonly adminModelManagerUpload = 'admin/model-manager/upload/execute';
  public readonly adminModelManagerUploadMitigations = 'admin/model-manager/upload-mitigations/execute';
  public readonly adminModelManagerUploadLookups = 'admin/model-manager/upload-lookups/execute';
  // Build
  public readonly buildFunctionCreate = 'build/function/create';
  public readonly buildFunctionRead = 'build/function/read';
  public readonly buildLookupCreate = 'build/lookup/create';
  public readonly buildLookupRead = 'build/lookup/read';

  public readonly buildLookupEdit = 'build/lookup/update';
  public readonly buildModelCreate = 'build/model/create';
  public readonly buildModelRead = 'build/model/read';
  public readonly buildModelEdit = 'build/model/update';
  public readonly buildModelDeleteNode = 'build/model/delete-node/execute';
  public readonly buildModelDownload = 'build/model/download/execute';

  // Model Builder
  public readonly modelBuilderDownload = 'build/lookup/download/execute';
  public readonly modelBuilderUpload = 'build/model/upload/execute';
  public readonly modelBuilderUploadLookups = 'build/lookup/upload/execute';

  // Events
  public readonly eventsEventItemCreate = 'events/event-item/create';
  public readonly eventsEventItemRead = 'events/event-item/read';
  public readonly eventsEventItemDelete = 'events/event-item/delete';
  public readonly eventsEventItemUpdate = 'events/event-item/update';
  public readonly eventsEventItemReactivate = 'events/event-item/reactivate/execute';

  // Hierarchy
  public readonly hierarchyHierarchyItemCreate = 'hierarchy/hierarchy-item/create';
  public readonly hierarchyHierarchyItemMediaAttachmentCreate = 'hierarchy/hierarchy-item/media-attachment/create';
  public readonly hierarchyHierarchyItemMediaAttachmentRead = 'hierarchy/hierarchy-item/media-attachment/read';
  public readonly hierarchyHierarchyItemProtectedEquipmentCreate = 'hierarchy/hierarchy-item/protected-equipment/create';
  public readonly hierarchyHierarchyItemProtectedEquipmentRead = 'hierarchy/hierarchy-item/protected-equipment/read';
  public readonly hierarchyHierarchyItemRead = 'hierarchy/hierarchy-item/read';
  public readonly hierarchyHierarchyItemUpdate = 'hierarchy/hierarchy-item/update';
  public readonly hierarchyHierarchyItemDelete = 'hierarchy/hierarchy-item/delete';
  public readonly hierarchyHierarchyItemUpdateTemplate = 'hierarchy/hierarchy-item/template/execute';
  public readonly hierarchyHierarchyItemUpdateStatus = 'hierarchy/hierarchy-item/status/execute';
  public readonly hierarchyHierarchyItemUpdateParent = 'hierarchy/hierarchy-item/parent/execute';
  public readonly hierarchyHierarchyItemUpdateLockedAttributes = 'hierarchy/hierarchy-item/locked-attributes/execute';
  // IDMS
  public readonly idmsInspectionReportCreate = 'idms/inspection-report/create';
  public readonly idmsInspectionReportRead = 'idms/inspection-report/read';
  public readonly idmsInspectionReportDelete = 'idms/inspection-report/delete';
  public readonly idmsInspectionReportUpdate = 'idms/inspection-report/update';
  public readonly idmsInspectionReportApproval = 'idms/inspection-report/approval/execute';
  public readonly idmsThicknessLocationCreate = 'idms/thickness-location/create';
  public readonly idmsThicknessLocationUpdate = 'idms/thickness-location/update';
  public readonly idmsThicknessLocationDelete = 'idms/thickness-location/delete';
  public readonly idmsThicknessLocationMediaAttachmentCreate = 'idms/thickness-location/media-attachment/create';
  public readonly idmsThicknessLocationMediaAttachmentRead = 'idms/thickness-location/media-attachment/read';
  public readonly idmsThicknessLocationRead = 'idms/thickness-location/read';
  public readonly idmsThicknessReportMediaAttachmentCreate = 'idms/thickness-report/media-attachment/create';
  public readonly idmsThicknessReportMediaAttachmentRead = 'idms/thickness-report/media-attachment/read';
  public readonly idmsThicknessReportRead = 'idms/thickness-report/read';
  public readonly idmsThicknessReportDelete = 'idms/thickness-report/delete';
  public readonly idmsThicknessReportCreate = 'idms/thickness-report/create';
  public readonly idmsThicknessReportUpdate = 'idms/thickness-report/update';
  public readonly idmsThicknessReportApproval = 'idms/thickness-report/approval/execute';

  // License
  public readonly licenceCreate = 'licence/create';
  public readonly licenceUpdate = 'licence/update';
  public readonly licenceRead = 'licence/read';
  // Maintenance
  public readonly maintenanceMaintenanceOptimizationRead = 'maintenance/maintenance-optimization/read';
  public readonly maintenanceMaintenanceOptimizationCreate = 'maintenance/maintenance-optimization/create';
  public readonly maintenanceMaintenanceOptimizationUpdate = 'maintenance/maintenance-optimization/update';
  public readonly maintenanceMaintenanceOptimizationCalculate = 'maintenance/maintenance-optimization/calculate/execute';
  public readonly maintenanceMaintenanceStrategyCreate = 'maintenance/maintenance-strategy/create';
  public readonly maintenanceMaintenanceStrategyUpdate = 'maintenance/maintenance-strategy/update';
  public readonly maintenanceMaintenanceStrategyRead = 'maintenance/maintenance-strategy/read';
  public readonly maintenanceMaintenanceStrategyActivate = 'maintenance/maintenance-strategy/activate/execute';
  // RBI
  public readonly rbiMitigationsMitigationPlanMediaAttachmentCreate = 'rbi/mitigations/mitigation-plan/media-attachment/create';
  public readonly rbiMitigationsMitigationPlanMediaAttachmentRead = 'rbi/mitigations/mitigation-plan/media-attachment/read';
  public readonly rbiMitigationsMitigationPlanTaskCreate = 'rbi/mitigations/mitigation-plan/task/create';
  public readonly rbiMitigationsMitigationPlanActivateExecute = 'rbi/mitigations/mitigation-plan/activate/execute';
  public readonly rbiMitigationsMitigationPlanAddAdHocTaskExecute = 'rbi/mitigations/mitigation-plan/add-ad-hoc-task/execute';
  public readonly rbiMitigationsMitigationPlanTaskRead = 'rbi/mitigations/mitigation-plan/task/read';
  public readonly rbiMitigationsMitigationPlanTaskUpdate = 'rbi/mitigations/mitigation-plan/task/update';
  public readonly rbiMitigationsMitigationPlanFrequencyOverrideExecute = 'rbi/mitigations/mitigation-plan/frequencyoverrides/execute';
  public readonly rbiMitigationsMitigationPlanDatesOverrideExecute = 'rbi/mitigations/mitigation-plan/datesoverrides/execute';
  public readonly rbiMitigationsRecommentationRead = 'rbi/mitigations/recommendation/read';
  public readonly rbiMitigationPlanTaskDeferralExecute = 'rbi/mitigations/mitigation-plan/task/deferral/execute';
  public readonly rbiRiskAnalysisInspectionHistoryRead = 'rbi/risk-analysis/inspection-history/read';
  public readonly rbiRiskAnalysisMassCriticalityCreate = 'rbi/risk-analysis/mass-criticality-results/create';
  public readonly rbiRiskAnalysisMassCriticalityRead = 'rbi/risk-analysis/mass-criticality-results/read';
  public readonly rbiRiskAnalysisMassCriticalityTemplatesRead = 'rbi/risk-analysis/mass-criticality-templates/read';
  public readonly rbiRiskAnalysisMassCriticalityTemplatesCreate = 'rbi/risk-analysis/mass-criticality-templates/create';
  public readonly rbiRiskAnalysisMassCriticalityTemplatesUpdate = 'rbi/risk-analysis/mass-criticality-templates/update';
  public readonly rbiRiskAnalysisMassCriticalityTemplatesDelete = 'rbi/risk-analysis/mass-criticality-templates/delete';
  public readonly rbiRiskAnalysisMassCriticalityTemplatesSave = 'rbi/risk-analysis/mass-criticality-templates/save/execute';
  public readonly rbiRiskAnalysisMassCriticalityTemplatesRun = 'rbi/risk-analysis/mass-criticality-templates/run/execute';
  public readonly rbiRiskAnalysisModelRunCreate = 'rbi/risk-analysis/model-run/create';
  public readonly rbiRiskAnalysisModelRunMediaAttachmentCreate = 'rbi/risk-analysis/model-run/media-attachment/create';
  public readonly rbiRiskAnalysisModelRunMediaAttachmentRead = 'rbi/risk-analysis/model-run/media-attachment/read';
  public readonly rbiRiskAnalysisModelRunRead = 'rbi/risk-analysis/model-run/read';
  public readonly rbiRiskAnalysisModelRunExecute = 'rbi/risk-analysis/model-run/execute';
  // Reports
  public readonly reportsAllRead = 'reports/*/read';
}
